module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/design-system-old-5f0c0f03371cf98b4c2b24b5c3734941.svg";